<template>
	<div class="pe-overlay">
		<div class="backdrop" :class="{ show: show }" @click="$emit('close')"></div>
		<div class="modal filter2" :class="{ show: show }" role="dialog" aria-modal="true">
			<div class="modal-head"><div>{{ title }} <span v-if="subtitle" class="muted">{{ subtitle }}</span></div><button class="navbtn close" aria-label="Close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button></div>
			<div class="f2-body">
				<div class="cat-list">
					<div class="cat-applied"><span>{{ appliedCount }} applied</span><a v-if="appliedCount" href="#" class="clear" @click.prevent="$emit('clear')">Clear</a></div>
					<button v-for="cat in categories" :key="cat.key" class="cat" :class="{ on: activeCat === cat.key }" @click="$emit('update:activeCat', cat.key)">
						<div class="cat-top"><span v-if="brandClass(cat.brand)" class="bdot" :class="brandClass(cat.brand)"></span><i v-else-if="cat.icon" :class="cat.icon"></i> {{ cat.label }}<i class="fa-solid fa-chevron-right car"></i></div>
						<div v-if="cat.chips && cat.chips.length" class="cat-chips"><span v-for="(ch, ci) in cat.chips" :key="ci" class="mchip">{{ ch }}</span></div>
					</button>
				</div>
				<div class="cat-detail"><slot name="detail" :cat="activeCat"></slot></div>
			</div>
			<div class="modal-foot"><slot name="foot-left"><span class="results">{{ resultsText }}</span></slot><div class="row"><button class="pill" @click="$emit('clear')">Clear all</button><button class="btn-primary" @click="$emit('primary')">{{ primaryLabel }}</button></div></div>
		</div>
	</div>
</template>

<script>
import { brandKey } from './PeBrandChip.vue'

export default {
	name: 'PeTwoPaneModal',
	props: {
		show: { type: Boolean, default: false },
		title: { type: String, default: 'Filters' },
		subtitle: { type: String, default: '' },
		categories: { type: Array, default: () => [] }, // [{ key, label, icon (FontAwesome class) or brand (TW, HG…), chips: [] }]
		activeCat: { type: String, default: '' }, // v-model via update:activeCat (.sync)
		appliedCount: { type: Number, default: 0 },
		resultsText: { type: String, default: '' },
		primaryLabel: { type: String, default: 'Show results' },
	},
	// The overlay lives in <body> like Accounts2's, so position:fixed and z-index are not trapped by a transformed ancestor.
	mounted() { if (this.$el.parentNode !== document.body) document.body.appendChild(this.$el) },
	beforeDestroy() { if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el) },
	methods: {
		brandClass(brand) { return brandKey(brand).toLowerCase() },
	},
}
</script>
